module.exports = __webpack_public_path__ + "static/media/Desktop_LearnAbout.e64f0ae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewcc/Desktop_LearnAbout.png
// module id = 99
// module chunks = 0